import { render, staticRenderFns } from "./UcFixedAssetWorkItemsPanel.yaml?vue&type=template&id=43c39ac4&component"
import script from "./UcFixedAssetWorkItemsPanel.yaml?vue&type=script&lang=ts&component"
export * from "./UcFixedAssetWorkItemsPanel.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports